const DEFAULT_LANG = 'en';
const getFormatter = (lang) => {
    try {
        return new Intl.NumberFormat(lang || DEFAULT_LANG);
    }
    catch (e) {
        return new Intl.NumberFormat(DEFAULT_LANG);
    }
};
export default function createFormatNumber(lang) {
    const formatter = getFormatter(lang);
    return (value) => {
        const number = typeof value === 'number' ? value : Number(value);
        return Number.isFinite(number) ? formatter.format(number) : String(value);
    };
}
//# sourceMappingURL=create-format-number.js.map